import { hot } from 'react-hot-loader/root';
import React from 'react';
import PropTypes from 'prop-types';

import PageWrapper from '../design-system/PageWrapper';
import PageSection from '../design-system/PageSection';
import Container from '../design-system/Containers';
import { HeadingArticle } from '../design-system/Headings';
import Paragraph from '../design-system/Paragraph';
import RichText, { FeatureHeadlineRenderer } from '../design-system/RichText';
import { LinkButton } from '../design-system/Buttons';
import RadarHeroPageSection from '../design-system/RadarHeroPageSection';

const OnboardingSplashPage = ({
  content: {
    heading,
    body,
    sidePanel,
  },
  gamesPath,
  phrases,
}) => (
  <PageWrapper tallNav bgDark>
    <RadarHeroPageSection center={false} container={false}>
      <Container small>
        <HeadingArticle el="h1">{heading}</HeadingArticle>
      </Container>
    </RadarHeroPageSection>
    <PageSection container={false}>
      <Container small>
        <RichText paragraphRenderer={FeatureHeadlineRenderer} content={body} />
        <LinkButton w100 href={gamesPath}>{phrases.startButtonLabel}</LinkButton>
        <Paragraph secondary>{sidePanel}</Paragraph>
      </Container>
    </PageSection>
  </PageWrapper>
);

OnboardingSplashPage.propTypes = {
  gamesPath: PropTypes.string.isRequired,
  content: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    sidePanel: PropTypes.string.isRequired,
  }).isRequired,
  phrases: PropTypes.exact({
    startButtonLabel: PropTypes.string,
  }).isRequired,
};

export default hot(OnboardingSplashPage);
